import { normalizeUserQuantity } from "../../../normalizers/normalizeUserQuantity";
import { upsertQuantity } from "../helper";


export function handleUserQuantityDefinitionDeleted(state, payload) {
    const nodeId = `uq${payload.quantity_definition_id}`

    const { [nodeId]: removed, ...quantitiesById } = state.quantitiesById;

    // 2. REMOVE from ALL categories
    const categoriesById = Object.fromEntries(
        Object.entries(state.categoriesById).map(([id, cat]) => [
            id,
            {
                ...cat,
                quantities: (cat.quantities || []).filter(
                    q => q.nodeId !== nodeId
                ),
            },
        ])
    );

    return {
        ...state,
        quantitiesById,
        categoriesById,
    };
}